<script lang="ts" setup>
import { onMounted, provide, shallowRef } from 'vue'
import { useFeatureFlags } from '@previo/feature-flags'
import router from '~/router'
import { LayoutComponents } from '~/layouts'

const layout = shallowRef<typeof LayoutComponents>()

router.afterEach((to) => {
  if (to.meta.layout) {
    layout.value = LayoutComponents[to.meta.layout]
  }
})

provide('app:layout', layout)

onMounted(() => {
  useFeatureFlags().startup()
})
</script>

<template>
  <main>
    <component :is="layout || 'div'">
      <slot />
    </component>
  </main>
</template>
